var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip, MobileIcon } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelMobileDiscountPill(_a) {
    var { chipProps } = _a, other = __rest(_a, ["chipProps"]);
    const { resourceStrings: { MOBILE_RATE_PILL_LABEL }, } = useGlobalContext();
    return (React.createElement(Chip, Object.assign({ color: "neutral", icon: React.createElement(MobileIcon, null) }, chipProps, { "data-id": "mobile-discount-pill" }, other), MOBILE_RATE_PILL_LABEL));
}
